import type { FeaturevisorInstance } from '@featurevisor/sdk';
import type { OrganizationContextSchemaT } from '../contexts/organization-context';

export const ToolsConfigurationFeature = (
  sdk: FeaturevisorInstance,
  context: OrganizationContextSchemaT
) => {
  const key = 'tools-configuration';

  const isEnabled = sdk.isEnabled(key, context);

  return {
    key,
    isEnabled,
  };
};
